import { createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "layer ly_pop login_info",
  style: {"display":"block"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "layer_tit" }, [
  /*#__PURE__*/_createVNode("h3", { class: "tit_txt" }, "클럽아티제 회원이신가요?"),
  /*#__PURE__*/_createVNode("p", { class: "desc_txt" }, "로그인 후 이용해주세요.")
], -1)
const _hoisted_3 = { class: "ly_btn_area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openLoginPopup'))),
        type: "button",
        class: "btn btn_login"
      }, "로그인"),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openCellphoneAuthenticationPopup'))),
        type: "button",
        class: "btn btn_nomember"
      }, [
        _renderSlot(_ctx.$slots, "text")
      ])
    ]),
    _createVNode("a", {
      href: "#",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('closeAuthenticationPromptPopup')), ["prevent"])),
      class: "btn_close"
    }, "팝업 닫기")
  ]))
}